import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from "@vueuse/core";
import { TabsRoot, useForwardPropsEmits } from "reka-ui";
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tabs',
    props: {
        defaultValue: { type: null, required: false },
        orientation: { type: String, required: false },
        dir: { type: String, required: false },
        activationMode: { type: String, required: false },
        modelValue: { type: null, required: false },
        unmountOnHide: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["update:modelValue"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegatedProps = reactiveOmit(props, "class");
        const forwarded = useForwardPropsEmits(delegatedProps, emits);
        const __returned__ = { props, emits, delegatedProps, forwarded, get TabsRoot() { return TabsRoot; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
